import axios from 'axios';
import { UIService } from '@/shared/services/ui.service';
import { useHealthStore } from '@/store';

export class HealthService {
    constructor(private uiService = new UIService()) {}

    async loadHealth(): Promise<void> {
        const healthStore = useHealthStore();

        try {
            const response = await axios.get(`${import.meta.env.VITE_API_URL}/health`, {
                headers: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    'Ocp-Apim-Subscription-Key': import.meta.env.VITE_API_KEY,
                },
            });

            healthStore.setHealth({
                status: response.data.status,
                version: response.data.version,
                timestamp: response.data.timestamp,
                checks: response.data.checks,
            });
        } catch (error) {
            this.uiService.notifyApiErrorAction(error);
            healthStore.reset();
        }
    }
}
